module.exports = __webpack_public_path__ + "img/icon_suporte_tecnico_servicos_home.f88ecdeb.svg";